/**
 * 애플리케이션 전체에서 사용되는 전역 상수들을 정의합니다.
 */

// Page-related constants
export const PAGE_FARM_SEARCH = 'farmSearch';
export const PAGE_SIRE_SELECTION = 'sireSelection';
export const PAGE_MATING_PLAN = 'matingPlan';
export const PAGE_INVENTORY = 'inventory';

// User-type related constants
export const USER_TYPE_FARM_OWNER = '2'; // 농장주
export const USER_TYPE_GENERAL = '1'; // 직원